<div class="title-container">
  <h1>Cliëntfiche van {{ client.getNaam() }}
    @if (client?.getFiche()?.getLaatstGewijzigdeTijdstip()) {
      <div
        class="mat-small laatst-gewijzigde-tijdstip">
        Laatst gewijzigd op {{ client?.getFiche()?.getLaatstGewijzigdeTijdstip() | date:'d/MM/yyyy' }}
      </div>
    }
  </h1>
  <div class="filler"></div>
  <div class="pdf-buttons">
    <button mat-raised-button
            color="primary"
            (click)="generateVolledigePDF()"
            [disabled]="!client.hasFiche()">PDF volledige versie
    </button>
    <button mat-raised-button
            color="primary"
            (click)="generateClientGerichtePDF()"
            [disabled]="!client.hasFiche()">PDF cliënt versie
    </button>
  </div>
</div>
<form
  [formGroup]="ClientFicheBeheerForm"
  (ngSubmit)="onOkClicked()">
  <div class="onderverdeling algemene-informatie">
    <h2 class="sub-title">Algemene informatie</h2>
    <div class="row">
      <mat-form-field>
        <mat-label>Dienstencheques</mat-label>
        <mat-select formControlName="dienstencheques">
          <mat-option></mat-option>
          @for (dienstenchequesType of dienstenchequesTypes; track dienstenchequesType) {
            <mat-option [value]="dienstenchequesType">
              {{ dienstenchequesType }}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
      <mat-form-field>
        <mat-label>Gebruikersnummer dienstencheques</mat-label>
        <input matInput
               formControlName="gebruikersnummer"
               type="text"
               placeholder="">
        @if (gebruikersnummer.hasError('pattern')) {
          <mat-error>Vul een nummer in</mat-error>
        }
      </mat-form-field>
      <mat-form-field (click)="picker.open()">
        <mat-label>Geboortedatum</mat-label>
        <input matInput
               [matDatepicker]="picker"
               formControlName="geboortedatum"
               placeholder="29/11/1993">
        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-datepicker #picker
                        startView="multi-year"
                        disabled="false">
        </mat-datepicker>
        @if (geboortedatum.hasError('futureDate')) {
          <mat-error>Datum moet in het verleden zijn</mat-error>
        }
        @if (geboortedatum.hasError('matDatepickerParse')) {
          <mat-error>Vul een correcte datum in</mat-error>
        }
      </mat-form-field>
    </div>
    <div class="row">
      <mat-form-field>
        <mat-label>Moedertaal</mat-label>
        <input matInput
               formControlName="moedertaal"
               type="text"
               placeholder="Bv. Turks">
      </mat-form-field>
      <mat-form-field>
        <mat-label>Taal waarin je met cliënt kan praten</mat-label>
        <input matInput
               formControlName="conversatieTaal"
               type="text"
               placeholder="Bv. Engels">
      </mat-form-field>
    </div>
    <mat-form-field>
      <mat-label>Key-lock code</mat-label>
      <input matInput
             formControlName="keyLock"
             type="text"
             placeholder="Code van de eventuele sleutelkast">
    </mat-form-field>
    <mat-form-field>
      <mat-label>Autostaanplaats / Parking in de buurt</mat-label>
      <input matInput
             formControlName="autoStaanPlaats"
             type="text"
             placeholder="">
    </mat-form-field>
    <mat-form-field>
      <mat-label>Extra info i.v.m. bereikbaarheid</mat-label>
      <textarea matInput
                cdkTextareaAutosize
                cdkAutosizeMinRows="2"
                cdkAutosizeMaxRows="10"
                formControlName="extraInfoBereikbaarheid"
                type="textarea"
                placeholder="Bv. Bushalte dichtbij"
                (keydown.enter)="$event.stopPropagation()">
      </textarea>
    </mat-form-field>
    <mat-form-field>
      <mat-label>Inwonende gezinsleden</mat-label>
      <textarea matInput
                cdkTextareaAutosize
                cdkAutosizeMinRows="2"
                cdkAutosizeMaxRows="10"
                formControlName="inwonendeGezinsleden"
                type="textarea"
                placeholder="Bv. 2 Inwonende tienerkinderen"
                (keydown.enter)="$event.stopPropagation()">
      </textarea>
    </mat-form-field>
    <mat-form-field>
      <mat-label>Korte sociale situatieschets</mat-label>
      <textarea matInput
                cdkTextareaAutosize
                cdkAutosizeMinRows="2"
                cdkAutosizeMaxRows="10"
                formControlName="socialeSituatieSchets"
                type="textarea"
                placeholder="Bv. Heeft vrienden en familie die dagelijks langskomen"
                (keydown.enter)="$event.stopPropagation()">
      </textarea>
    </mat-form-field>
    <mat-form-field>
      <mat-label>Extra informatie/aandachtspunten</mat-label>
      <textarea matInput
                cdkTextareaAutosize
                cdkAutosizeMinRows="2"
                cdkAutosizeMaxRows="10"
                formControlName="extraInformatie"
                type="textarea"
                placeholder="Bv. Praat zeer snel"
                (keydown.enter)="$event.stopPropagation()">
      </textarea>
    </mat-form-field>
  </div>

  <div class="onderverdeling takenpakket">
    <h2 class="sub-title">Takenpakket binnen Zorg Leuven</h2>
    <mat-form-field>
      <mat-label>Reden van opstart</mat-label>
      <textarea matInput
                cdkTextareaAutosize
                cdkAutosizeMinRows="2"
                cdkAutosizeMaxRows="10"
                formControlName="redenOpstart"
                type="textarea"
                placeholder="Bv. Ziekenhuisopname"
                (keydown.enter)="$event.stopPropagation()">
      </textarea>
    </mat-form-field>
    <mat-form-field>
      <mat-label>Te behalen doelstellingen</mat-label>
      <textarea matInput
                cdkTextareaAutosize
                cdkAutosizeMinRows="2"
                cdkAutosizeMaxRows="10"
                formControlName="teBehalenDoelstellingen"
                type="textarea"
                placeholder="Bv. Mevrouw helpen bij het structureren van haar huishouden"
                (keydown.enter)="$event.stopPropagation()">
      </textarea>
    </mat-form-field>

    <h3>Poetsdienst</h3>
    <div class="column">
      <div class="row">
        <mat-form-field>
          <mat-label>Status</mat-label>
          <mat-select formControlName="poetsdienstStatus">
            <mat-option></mat-option>
            @for (status of takenpakketCategorieStatus; track status) {
              <mat-option [value]="status">
                {{ status }}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
        <mat-form-field>
          <mat-label>Frequentie</mat-label>
          <input matInput
                 formControlName="poetsdienstFrequentie"
                 type="text"
                 placeholder="">
        </mat-form-field>
      </div>
      <mat-form-field>
        <mat-label>Vaste huishoudhulpen</mat-label>
        <textarea matInput
                  cdkTextareaAutosize
                  cdkAutosizeMinRows="2"
                  cdkAutosizeMaxRows="10"
                  formControlName="poetsdienstVasteMedewerkers"
                  type="textarea"
                  placeholder=""
                  (keydown.enter)="$event.stopPropagation()">
        </textarea>
      </mat-form-field>
      <mat-form-field>
        <mat-label>Belangrijkste taken</mat-label>
        <textarea matInput
                  cdkTextareaAutosize
                  cdkAutosizeMinRows="2"
                  cdkAutosizeMaxRows="10"
                  formControlName="poetsdienstBelangrijksteTaken"
                  type="textarea"
                  placeholder=""
                  (keydown.enter)="$event.stopPropagation()">
        </textarea>
      </mat-form-field>
    </div>

    <h3>Gezinszorg</h3>
    <div class="column">
      <div class="row">
        <mat-form-field>
          <mat-label>Status</mat-label>
          <mat-select formControlName="gezinszorgStatus">
            <mat-option></mat-option>
            @for (status of takenpakketCategorieStatus; track status) {
              <mat-option [value]="status">
                {{ status }}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
        <mat-form-field>
          <mat-label>Frequentie</mat-label>
          <input matInput
                 formControlName="gezinszorgFrequentie"
                 type="text"
                 placeholder="">
        </mat-form-field>
      </div>
      <mat-form-field>
        <mat-label>Vaste verzorgenden</mat-label>
        <textarea matInput
                  cdkTextareaAutosize
                  cdkAutosizeMinRows="2"
                  cdkAutosizeMaxRows="10"
                  formControlName="gezinszorgVasteMedewerkers"
                  type="textarea"
                  placeholder=""
                  (keydown.enter)="$event.stopPropagation()">
        </textarea>
      </mat-form-field>
      <mat-form-field>
        <mat-label>Belangrijkste taken</mat-label>
        <textarea matInput
                  cdkTextareaAutosize
                  cdkAutosizeMinRows="2"
                  cdkAutosizeMaxRows="10"
                  formControlName="gezinszorgBelangrijksteTaken"
                  type="textarea"
                  placeholder=""
                  (keydown.enter)="$event.stopPropagation()">
        </textarea>
      </mat-form-field>
      <mat-form-field>
        <mat-label>Specifieke informatie voor het weekend (vb. taken, aandachtspunten, bepaalde uren waar rekening mee
          gehouden moet worden,...)
        </mat-label>
        <textarea matInput
                  cdkTextareaAutosize
                  cdkAutosizeMinRows="2"
                  cdkAutosizeMaxRows="10"
                  formControlName="gezinszorgSpecifiekeInformatieVoorWeekend"
                  type="textarea"
                  placeholder="Bv. Steeds een maaltijd maken. Cliënt eet altijd om 12 uur."
                  (keydown.enter)="$event.stopPropagation()">
        </textarea>
      </mat-form-field>
    </div>

    <h3>Maaltijden aan huis</h3>
    <div class="column">
      <div class="row">
        <mat-form-field>
          <mat-label>Status</mat-label>
          <mat-select formControlName="maaltijdenAanHuisStatus">
            <mat-option></mat-option>
            @for (status of takenpakketCategorieStatus; track status) {
              <mat-option [value]="status">
                {{ status }}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
        <mat-form-field>
          <mat-label>Frequentie</mat-label>
          <input matInput
                 formControlName="maaltijdenAanHuisFrequentie"
                 type="text"
                 placeholder="">
        </mat-form-field>
      </div>
      <mat-form-field>
        <mat-label>Belangrijkste taken</mat-label>
        <textarea matInput
                  cdkTextareaAutosize
                  cdkAutosizeMinRows="2"
                  cdkAutosizeMaxRows="10"
                  formControlName="maaltijdenAanHuisBelangrijksteTaken"
                  type="textarea"
                  placeholder=""
                  (keydown.enter)="$event.stopPropagation()">
        </textarea>
      </mat-form-field>
    </div>

    <h3>Klusjesdienst</h3>
    <mat-form-field>
      <mat-label>Status</mat-label>
      <mat-select formControlName="klusjesdienstStatus">
        <mat-option></mat-option>
        @for (status of takenpakketCategorieStatus; track status) {
          <mat-option [value]="status">
            {{ status }}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>
    <mat-form-field class="flex-2">
      <mat-label>Belangrijkste taken</mat-label>
      <textarea matInput
                cdkTextareaAutosize
                cdkAutosizeMinRows="2"
                cdkAutosizeMaxRows="10"
                formControlName="klusjesdienstBelangrijksteTaken"
                type="textarea"
                placeholder=""
                (keydown.enter)="$event.stopPropagation()">
      </textarea>
    </mat-form-field>

    <h3>Eerstelijnspsycholoog</h3>
    <mat-form-field>
      <mat-label>Status</mat-label>
      <mat-select formControlName="psycholoogStatus">
        <mat-option></mat-option>
        @for (status of takenpakketCategorieStatus; track status) {
          <mat-option [value]="status">
            {{ status }}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>
    <mat-form-field class="flex-2">
      <mat-label>Belangrijkste taken</mat-label>
      <textarea matInput
                cdkTextareaAutosize
                cdkAutosizeMinRows="2"
                cdkAutosizeMaxRows="10"
                formControlName="psycholoogBelangrijksteTaken"
                type="textarea"
                placeholder=""
                (keydown.enter)="$event.stopPropagation()">
      </textarea>
    </mat-form-field>

    <h3>Ergotherapeut</h3>
    <mat-form-field>
      <mat-label>Status</mat-label>
      <mat-select formControlName="ergotherapeutStatus">
        <mat-option></mat-option>
        @for (status of takenpakketCategorieStatus; track status) {
          <mat-option [value]="status">
            {{ status }}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>
    <mat-form-field class="flex-2">
      <mat-label>Belangrijkste taken</mat-label>
      <textarea matInput
                cdkTextareaAutosize
                cdkAutosizeMinRows="2"
                cdkAutosizeMaxRows="10"
                formControlName="ergotherapeutBelangrijksteTaken"
                type="textarea"
                placeholder=""
                (keydown.enter)="$event.stopPropagation()">
      </textarea>
    </mat-form-field>

    <h3>Mantelzorgcoördinator</h3>
    <mat-form-field>
      <mat-label>Status</mat-label>
      <mat-select formControlName="mantelzorgcoordinatorStatus">
        <mat-option></mat-option>
        @for (status of takenpakketCategorieStatus; track status) {
          <mat-option [value]="status">
            {{ status }}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>
    <mat-form-field class="flex-2">
      <mat-label>Belangrijkste taken</mat-label>
      <textarea matInput
                cdkTextareaAutosize
                cdkAutosizeMinRows="2"
                cdkAutosizeMaxRows="10"
                formControlName="mantelzorgcoordinatorBelangrijksteTaken"
                type="textarea"
                placeholder=""
                (keydown.enter)="$event.stopPropagation()">
      </textarea>
    </mat-form-field>

    <h3>Casemanager</h3>
    <mat-form-field>
      <mat-label>Status</mat-label>
      <mat-select formControlName="casemanagerStatus">
        <mat-option></mat-option>
        @for (status of takenpakketCategorieStatus; track status) {
          <mat-option [value]="status">
            {{ status }}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>
    <mat-form-field class="flex-2">
      <mat-label>Belangrijkste taken</mat-label>
      <textarea matInput
                cdkTextareaAutosize
                cdkAutosizeMinRows="2"
                cdkAutosizeMaxRows="10"
                formControlName="casemanagerBelangrijksteTaken"
                type="textarea"
                placeholder=""
                (keydown.enter)="$event.stopPropagation()">
      </textarea>
    </mat-form-field>

    <h3>Casa Clementina</h3>
    <h4>Contactpersoon in noodgeval</h4>
    <div class="row">
      <mat-form-field>
        <mat-label>Naam</mat-label>
        <input matInput
               formControlName="casaClementinaContactpersoonNoodgevalNaam"
               type="text"
               placeholder="">
      </mat-form-field>
      <mat-form-field>
        <mat-label>Relatie tot hulpvrager</mat-label>
        <input matInput
               formControlName="casaClementinaContactpersoonNoodgevalRelatieTotHulpvrager"
               type="text"
               placeholder="">
      </mat-form-field>
      <mat-form-field>
        <mat-label>Telefoonnummer</mat-label>
        <input matInput
               formControlName="casaClementinaContactpersoonNoodgevalTelefoonnummer"
               type="text"
               placeholder="">
      </mat-form-field>
    </div>
    <mat-form-field>
      <mat-label>Aandachtspunten en gemaakte afspraken</mat-label>
      <textarea matInput
                cdkTextareaAutosize
                cdkAutosizeMinRows="2"
                cdkAutosizeMaxRows="10"
                formControlName="casaClementinaAandachtspuntenEnGemaakteAfspraken"
                type="textarea"
                placeholder=""
                (keydown.enter)="$event.stopPropagation()">
      </textarea>
    </mat-form-field>
    <div class="row">
      <mat-form-field>
        <mat-label>Hoe geraakt cliënt in Casa Clementina</mat-label>
        <mat-select multiple formControlName="casaClementinaTransportOptiesNaarCasaClementina">
          @for (transportOptie of transportOptiesNaarCasaClementina; track transportOptie) {
            <mat-option
              [value]="transportOptie">
              {{ transportOptie }}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
      <mat-form-field>
        <mat-label>Verduidelijk andere</mat-label>
        <input matInput
               formControlName="casaClementinaVerduidelijkingAndereTransportOptieNaarCasaClementina"
               type="text"
               placeholder="">
      </mat-form-field>
    </div>
    <mat-form-field>
      <mat-label>Financieel</mat-label>
      <mat-select multiple formControlName="casaClementinaFinancieleOpties">
        @for (financieelOptie of financieleOptiesCasaClementina; track financieelOptie) {
          <mat-option
            [value]="financieelOptie">
            {{ financieelOptie }}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>

    <h3>Waar te vinden</h3>
    <mat-form-field>
      <mat-label>Waar stofzuiger te vinden</mat-label>
      <input matInput
             formControlName="stofzuigerWaarTeVinden"
             type="text"
             placeholder="">
    </mat-form-field>
    <mat-form-field>
      <mat-label>Waar poetsproducten te vinden</mat-label>
      <input matInput
             formControlName="poetsproductenWaarTeVinden"
             type="text"
             placeholder="">
    </mat-form-field>
    <mat-form-field>
      <mat-label>Waar doeken/vodden/dweilen te vinden</mat-label>
      <input matInput
             formControlName="doekenVoddenDweilenWaarTeVinden"
             type="text"
             placeholder="">
    </mat-form-field>
    <mat-form-field>
      <mat-label>Waar telescopische steel te vinden</mat-label>
      <input matInput
             formControlName="telescopischeSteelWaarTeVinden"
             type="text"
             placeholder="">
    </mat-form-field>
    <mat-form-field>
      <mat-label>Waar ander poetsmateriaal te vinden</mat-label>
      <input matInput
             formControlName="andereWaarTeVinden"
             type="text"
             placeholder="">
    </mat-form-field>

    <h3>Aandachtspunten</h3>
    <mat-form-field>
      <mat-label>Aandachtspunten bij het poetsen</mat-label>
      <textarea matInput
                cdkTextareaAutosize
                cdkAutosizeMinRows="2"
                cdkAutosizeMaxRows="10"
                formControlName="aandachtspuntenPoetsen"
                type="textarea"
                placeholder="Bv. In de woonkamer is er een delicate vloer die snel krast."
                (keydown.enter)="$event.stopPropagation()">
      </textarea>
    </mat-form-field>
    <mat-form-field>
      <mat-label>Aandachtspunten bij andere taken</mat-label>
      <textarea matInput
                cdkTextareaAutosize
                cdkAutosizeMinRows="2"
                cdkAutosizeMaxRows="10"
                formControlName="aandachtspuntenAndereTaken"
                type="textarea"
                placeholder="Bv. Mevrouw maakt liefst samen het boodschappen lijstje op."
                (keydown.enter)="$event.stopPropagation()">
      </textarea>
    </mat-form-field>
  </div>

  <div class="onderverdeling knelpunten">
    <h2 class="sub-title">Knelpunten</h2>
    <mat-form-field>
      <mat-label>Allergieën</mat-label>
      <input matInput
             formControlName="allergieen"
             type="text"
             placeholder="Bv. Notenallergie Bv. Huisstofmijtallergie">
    </mat-form-field>
    <mat-form-field>
      <mat-label>Huisdieren</mat-label>
      <input matInput
             formControlName="huisdieren"
             type="text"
             placeholder="Bv. 2 Katten en 1 hond">
    </mat-form-field>
    <mat-form-field>
      <mat-label>Roken</mat-label>
      <input matInput
             formControlName="roken"
             type="text"
             placeholder="Bv.Ja">
    </mat-form-field>
  </div>

  <div class="onderverdeling mogelijke-problematieken">
    <h2 class="sub-title">Mogelijke problematieken</h2>
    <mat-form-field>
      <mat-label>Fysiek</mat-label>
      <textarea matInput
                cdkTextareaAutosize
                cdkAutosizeMinRows="2"
                cdkAutosizeMaxRows="10"
                formControlName="fysiekeProblematieken"
                type="textarea"
                placeholder="Bv. Meneer gebruikt bij verplaatsingen in huis de rollator."
                (keydown.enter)="$event.stopPropagation()">
      </textarea>
    </mat-form-field>
    <mat-form-field>
      <mat-label>Mentaal</mat-label>
      <textarea matInput
                cdkTextareaAutosize
                cdkAutosizeMinRows="2"
                cdkAutosizeMaxRows="10"
                formControlName="mentaleProblematieken"
                type="textarea"
                placeholder="Bv. Meneer heeft autisme."
                (keydown.enter)="$event.stopPropagation()">
      </textarea>
    </mat-form-field>
    <mat-form-field>
      <mat-label>Indien psy-cliënt: handvaten om met deze cliënt om te gaan</mat-label>
      <textarea matInput
                cdkTextareaAutosize
                cdkAutosizeMinRows="2"
                cdkAutosizeMaxRows="10"
                formControlName="handvatenOmMetClientOmTeGaan"
                type="textarea"
                placeholder="Bv. Veel lawaai zorgt bij meneer voor onrust. Geluidsprikkels tot een minimum beperken."
                (keydown.enter)="$event.stopPropagation()">
      </textarea>
    </mat-form-field>
    <mat-form-field>
      <mat-label>Financieel</mat-label>
      <textarea matInput
                cdkTextareaAutosize
                cdkAutosizeMinRows="2"
                cdkAutosizeMaxRows="10"
                formControlName="financieleProblematieken"
                type="textarea"
                placeholder="Bv. Bewindvoering. Geld voor boodschappen wordt gestort op woensdag."
                (keydown.enter)="$event.stopPropagation()">
      </textarea>
    </mat-form-field>
    <mat-form-field>
      <mat-label>Andere problematieken</mat-label>
      <textarea matInput
                cdkTextareaAutosize
                cdkAutosizeMinRows="2"
                cdkAutosizeMaxRows="10"
                formControlName="andereProblematieken"
                type="textarea"
                placeholder=""
                (keydown.enter)="$event.stopPropagation()">
      </textarea>
    </mat-form-field>
    <mat-form-field>
      <mat-label>Afsprakennota – korte samenvatting</mat-label>
      <textarea matInput
                cdkTextareaAutosize
                cdkAutosizeMinRows="2"
                cdkAutosizeMaxRows="10"
                formControlName="afsprakennota"
                type="textarea"
                placeholder=""
                (keydown.enter)="$event.stopPropagation()">
      </textarea>
    </mat-form-field>
  </div>

  <div class="onderverdeling andere-diensten">
    <h2 class="sub-title">Andere diensten</h2>
    <ng-container formArrayName="andereDiensten">
      @for (andereDienstForm of andereDiensten.controls; track andereDienstForm; let i = $index; let isLast = $last) {
        <ng-container
          [formGroupName]="i">
          <div class="row">
            <mat-form-field>
              <mat-label>Functie</mat-label>
              <input matInput
                     formControlName="functieAndereDienst"
                     type="text"
                     placeholder="Bv. Thuisverpleging">
            </mat-form-field>
            <mat-form-field>
              <mat-label>Naam dienstverlener/organisatie</mat-label>
              <input matInput
                     formControlName="naamDienstverlenerOfOrganisatieAndereDienst"
                     type="text"
                     placeholder="Bv. Wit-Gele Kruis">
            </mat-form-field>
            <mat-form-field>
              <mat-label>Extra info</mat-label>
              <input matInput
                     formControlName="extraInfoAndereDienst"
                     type="text"
                     placeholder="Bv. 2 keer per week">
            </mat-form-field>
            @if (!isLast) {
              <mat-action-row class="center-with-mat-input">
                <button mat-icon-button
                        color="primary"
                        type="button"
                        (click)="onDeleteAndereDienstClick(i)">
                  <mat-icon>delete_outline</mat-icon>
                </button>
              </mat-action-row>
            }
            @if (isLast) {
              <mat-action-row class="center-with-mat-input">
                <button mat-icon-button
                        color="primary"
                        type="button"
                        disabled>
                  <mat-icon>delete_outline</mat-icon>
                </button>
              </mat-action-row>
            }
          </div>
        </ng-container>
      }
    </ng-container>
  </div>
  <div class="actions">
    <button mat-button
            color="primary"
            type="button"
            (click)="onCancelClicked()">
      Annuleer
    </button>
    <button mat-raised-button
            color="primary"
            type="submit"
            [disabled]="ClientFicheBeheerForm.disabled || ClientFicheBeheerForm.invalid">
      Bewaar
    </button>
  </div>
</form>
